import { Phone, MapPin, ShieldCheck } from "lucide-react";
import Logo from "./Logo";
import { scrollToId } from "../lib/scroll";
import { whatsappLink, WHATSAPP_DISPLAY } from "../lib/api";

const Footer = ({ onQuote }) => (
  <footer className="bg-[#141312] text-[#FAF8F5]">
    <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16 lg:py-20">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo dark />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#FAF8F5]/55 font-light">
            Wholesale investment-grade gold bullion, sold direct from our mines and sales headquarters in
            Liberia to institutions and serious buyers worldwide.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] mb-5">Contact</p>
          <a
            data-testid="footer-whatsapp-link"
            href={whatsappLink("Hello Pacific Gold, I would like to inquire about a wholesale gold order")}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 text-sm text-[#FAF8F5]/80 hover:text-[#D4AF37] transition-colors duration-300"
          >
            <Phone size={15} className="text-[#C5A059]" /> {WHATSAPP_DISPLAY}
          </a>
          <p className="flex items-start gap-3 text-sm text-[#FAF8F5]/80 mt-4">
            <MapPin size={15} className="text-[#C5A059] mt-0.5 shrink-0" />
            Sales HQ — Monrovia, Liberia
          </p>
        </div>
        <div className="md:col-span-4">
          <p className="text-[10px] tracking-[0.28em] uppercase text-[#D4AF37] mb-5">Wholesale terms</p>
          <ul className="space-y-3 text-sm text-[#FAF8F5]/80">
            <li className="flex items-center gap-3">
              <ShieldCheck size={15} className="text-[#C5A059]" /> Minimum order — 500 g
            </li>
            <li className="flex items-center gap-3">
              <ShieldCheck size={15} className="text-[#C5A059]" /> Prices from — $60,000
            </li>
            <li className="flex items-center gap-3">
              <ShieldCheck size={15} className="text-[#C5A059]" /> 999.9 fine gold, assay-certified
            </li>
          </ul>
          <button
            data-testid="footer-quote-button"
            onClick={onQuote}
            className="mt-7 text-[12px] tracking-[0.18em] uppercase text-[#D4AF37] border-b border-[#D4AF37]/40 pb-1 hover:text-[#FAF8F5] hover:border-[#FAF8F5]/60 transition-colors duration-300"
          >
            Request a quote
          </button>
        </div>
      </div>
      <div className="mt-14 pt-7 border-t border-[#FAF8F5]/10 flex flex-wrap items-center justify-between gap-4">
        <p className="text-[11px] text-[#FAF8F5]/40 font-mono tracking-wide">© 2026 Pacific Gold · Monrovia, Liberia</p>
        <a data-testid="footer-admin-link" href="/admin" className="text-[11px] tracking-[0.2em] uppercase text-[#FAF8F5]/40 hover:text-[#D4AF37] transition-colors duration-300">
          Admin
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
